module.exports = __webpack_public_path__ + "media/images/google-button-27bdda9c4bf09c08773abc6fc231a982.svg";